export default __webpack_public_path__ + "static/media/crown.72be10ed.svg";